import React, { ChangeEvent, useState } from 'react';
import { IAnswerDetails } from '@root/types';
import styled from 'styled-components';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import Answers from '@root/db/entity/Answers';
import BarChart from '../../charts/BarChart';

import { ResultCard, TitleContainer } from './styles';
import { countQuestionRanges } from '../../../utils/getBarChartData';

interface IProps {
  resultData: Answers;
  allAnswerData: Answers[];
}

// interface IFilterState {
//   industry: boolean;
//   region: boolean;
// }

const RightCard = ({ resultData, allAnswerData }: IProps) => {
  const { answers } = resultData;

  // const [filter, setFilter] = useState<IFilterState>({
  //   industry: false,
  //   region: false,
  // });

  const [activeQuestion, setActiveQuestion] = useState<IAnswerDetails>(
    answers[0],
  );

  // const [stats, setStats] = useState<IRangeCountByQuestion[]>(
  //   countQuestionRanges(allAnswerData),
  // );

  const stats = countQuestionRanges(allAnswerData);

  // useEffect(() => {
  //   if (filter.industry && filter.region) {
  //     setStats(
  //       countQuestionRanges(
  //         filterByIndustry(
  //           filterByRegion(allAnswerData, resultData.region),
  //           resultData.industry,
  //         ),
  //       ),
  //     );
  //   }
  //   if (filter.industry && !filter.region) {
  //     setStats(
  //       countQuestionRanges(
  //         filterByIndustry(allAnswerData, resultData.industry),
  //       ),
  //     );
  //   }
  //   if (!filter.industry && filter.region) {
  //     setStats(
  //       countQuestionRanges(filterByRegion(allAnswerData, resultData.region)),
  //     );
  //   } else {
  //     setStats(countQuestionRanges(allAnswerData));
  //   }
  // }, [allAnswerData, filter, resultData.industry, resultData.region]);

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    const newQuestion = answers.find((question) => {
      return question.questionId === event.target.value;
    });
    setActiveQuestion(newQuestion || answers[0]);
  };

  const getChartData = () => {
    const foundQuestion = stats.find(
      (question) => question.questionId === activeQuestion.questionId,
    );
    if (foundQuestion) {
      return foundQuestion.rangeCount.map((range) => range.count);
    }
    throw new Error('There was an error calculating the statistics.');
  };

  return (
    <ResultCard>
      <TitleContainer>Question results</TitleContainer>
      <StyledFormControl variant="outlined">
        <Select value={activeQuestion.questionId} onChange={handleChange}>
          <MenuItem value="">
            <em>-- Select a question --</em>
          </MenuItem>
          {answers.map((answer) => {
            return (
              <MenuItem key={answer.questionId} value={answer.questionId}>
                {answer.title}
              </MenuItem>
            );
          })}
        </Select>
      </StyledFormControl>

      <TitleContainer>
        {
          answers.find((question) => {
            return question.questionId === activeQuestion.questionId;
          })?.title
        }
      </TitleContainer>

      <ScoreContainer>
        <BodyTypography>Your answer score was:</BodyTypography>
        <ScoreTypography>{activeQuestion.score} / 100</ScoreTypography>
      </ScoreContainer>
      <ChartContainer>
        <BarChart
          data={getChartData()}
          labels={['0-19', '20-39', '40-59', '60-79', '80-100']}
          userRange={activeQuestion.range}
          yLabel="Number of responses"
          xLabel="Score range"
        />
      </ChartContainer>
      {/* TODO: Layout is working, but filtering needs to be fixed in a later version. Disabling for now.
      <FilterContainer>
        <TitleContainer>Filter results</TitleContainer>
        <FormControlLabel
          control={<Checkbox name="same-region" />}
          label="Distributors in same region"
          onChange={() => setFilter({ ...filter, region: !filter.region })}
        />
        <FormControlLabel
          control={<Checkbox name="same-industry" />}
          label="Distributors in same industry"
          onChange={() => setFilter({ ...filter, industry: !filter.industry })}
        />
      </FilterContainer> */}
    </ResultCard>
  );
};

// const FilterContainer = styled.div`
//   border: 1px solid #e0e0e0;
//   border-radius: 4px;
//   padding: 10px;
//   margin: 10px;
// `;

const ChartContainer = styled.div`
  width: 511px;
  height: 245px;
`;

const ScoreTypography = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 72px;
  letter-spacing: -0.5000000596046448px;
  text-align: left;
`;

const ScoreContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 15px 0px 15px 0px;
`;

const BodyTypography = styled.div`
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;

const StyledFormControl = styled(FormControl)`
  width: 90%;
  height: 56px;
  margin-bottom: 30px;
`;

export default RightCard;
